    import React from 'react'
    import { useLocation } from 'react-router-dom';
    
    const Loader = () => {
      const location = useLocation();
      const isHomePage = location.pathname === '/';

      return (
        <div id="innerpreloader">
          {isHomePage ? 
            <img className='innerpreloader_image' src="/assets/images/whiteloader.png" alt="Loading......" />
            :
            <img className='innerpreloader_image' src="/assets/images/pageloader.png" alt="Loading......" />
          }
        </div> 
      )
    }
    
    export default Loader
    
